export const SET_SHOW_WELCOME_POPUP =
  "FEATURES/ONBOARDING/SET_SHOW_WELCOME_POPUP";
export const SET_SHOW_SORRY_POPUP = "FEATURES/ONBOARDING/SET_SHOW_SORRY_POPUP";
